/**
 * QA-593 아티스트 쇼핑몰 노출/숨김 — BE partner `displayed`(BO-TO-BE-2026-10-28-artist-displayed-qa593).
 * 활성/비활성(보관)과 따로, 활성 아티스트를 쇼핑몰에서만 숨긴다. 응답에 필드가 없으면(BE 반영 전) undefined —
 * 화면은 배지·버튼을 숨긴다.
 */
export const artistDisplayedOf = (a: unknown): boolean | undefined => {
  const v = (a as { displayed?: unknown } | null | undefined)?.displayed;
  return typeof v === 'boolean' ? v : undefined;
};
